// Components==============
import { faFilter } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dropdown from 'components/UI/Dropdown';
import SearchBar from 'components/UI/SearchBar';
import React, { useContext } from 'react';
// eslint-disable-next-line import/named
import { GroeiContext } from 'screens/Groei';
import {
    experienceNeededOptions,
    targetGroupOptions,
    themeOptions,
    startMonthOptions,
    enrollmentOptions,
} from 'utilities/filterOptions';
import './index.module.scss';

// =========================

export default function Filter() {
    const {
        searchValue,
        setSearchValue,
        targetGroupSelected,
        setTargetGroupSelected,
        themeSelected,
        setThemeSelected,
        experienceSelected,
        setExperienceSelected,
        startMonthSelected,
        setStartMonthSelected,
    } = useContext(GroeiContext);

    const startOptionsSorted = startMonthOptions
        .sort(
            (a, b) =>
                new Date(`01-${a.short}-2021`) - new Date(`01-${b.short}-2021`) < 0 ? -1 : 1 // eslint-disable-line
        )
        .filter((option) => option.short >= new Date().getMonth() + 1)
        .concat(
            startMonthOptions
                .sort(
                    (a, b) =>
                        new Date(`01-${a.short}-2021`) -
                            new Date(`01-${b.short}-2021`) <
                        0
                            ? -1
                            : 1 // eslint-disable-line
                )
                .filter((option) => option.short < new Date().getMonth() + 1)
        )
        .concat(enrollmentOptions);

    return (
        <div styleName="wrapper">
            <div styleName="grid">
                <div styleName="item-1">
                    <SearchBar
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                    />
                </div>
                <p styleName="text">
                    <FontAwesomeIcon icon={faFilter} /> Filters
                </p>
                <div styleName="item-2">
                    <Dropdown
                        text="Doelgroep"
                        options={targetGroupOptions.map((e) => e.long)}
                        selected={targetGroupSelected}
                        setSelected={setTargetGroupSelected}
                    />
                </div>
                <div styleName="item-3">
                    <Dropdown
                        text="Thema's"
                        options={themeOptions.map((e) => e.long)}
                        selected={themeSelected}
                        setSelected={setThemeSelected}
                    />
                </div>
                <div styleName="item-4">
                    <Dropdown
                        text="Ervaring"
                        options={experienceNeededOptions.map((e) => e.long)}
                        selected={experienceSelected}
                        setSelected={setExperienceSelected}
                    />
                </div>
                <div styleName="item-5">
                    <Dropdown
                        text="Startdatum"
                        type="month"
                        options={startOptionsSorted.map((e) => e.long)}
                        selected={startMonthSelected}
                        setSelected={setStartMonthSelected}
                    />
                </div>
            </div>
        </div>
    );
}
